<template>
  <section ref="anchor" class="transition">
    <div class="transition__content">
      <div class="transition__content_left">
        <div class="font-32-40 transition__content_title">
          {{ content.title }}
        </div>

        <div class="font-18-24 transition__content_title">
          {{ content.description }}
        </div>
      </div>

      <div class="font-small button" @click="$emit('show-form-presentation')">
        {{ content.button }}
      </div>
    </div>
  </section>
</template>

<script>
import { electronicTransitionData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicTransition',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicTransitionData,
    }
  },
}
</script>

<style lang="sass" scoped>
.transition
  padding: 0 $desktopHorizontalPaddings 8rem
  @media (max-width: 1279px)
    padding: 0 $mobileHorizontalPaddings 4rem
  &__content
    background: $textPrimary
    padding: 4rem
    border-radius: 30px
    display: flex
    justify-content: space-between
    gap: 3rem
    align-items: center
    @media (max-width: 1279px)
      flex-direction: column
      justify-content: flex-start
      margin-top: 2.4rem
      margin-bottom: 0
      align-items: flex-start
    &_title
      color: $textWhite

    &_left
      display: flex
      flex-direction: column
      gap: 16px

.button
  min-width: 300px
  height: 5rem
  padding: 1rem 3rem
  border-radius: 50px
  background-color: $buttonPrimary
  display: flex
  justify-content: center
  align-items: center
  color: $textWhite
  cursor: pointer
  transition: background-color 0.3s ease
  @media (max-width: 1279px)
    min-width: 100%
  @media (max-width: 768px)
    height: auto
</style>
